import { useRequest } from 'ahooks'

import { message } from 'antd'
import {
  addReport,
  AddReportData,
  deleteReport,
  DeleteReportData,
  downloadReport,
  DownloadReportData,
  getMenu,
  getReportList,
  GetReportListData,
  getScenariosExecutions,
  getTaskOption,
  GetTaskOptionData,
  viewReport,
  ViewReportData,
  wsUrl,
} from '@/api/evaluation'
import { queryEmailList, QueryEmailListParams } from '@/api/account-center/email-manage'
import { Message } from '@/components/message'
import { CreateReportParams } from './create-modal'
import { t } from '@/i18n'
export const useGetReportList = () => {
  const { data, runAsync: run } = useRequest((params: GetReportListData) => getReportList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('列表加载失败'))
    },
  })

  return [run] as const
}

export const useGetTaskOption = () => {
  const { runAsync, loading, data } = useRequest(
    (param: GetTaskOptionData) => getTaskOption(param),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('获取任务失败'))
      },
    },
  )
  data?.data?.items?.forEach(item => {
    item.label = `${item.name} ${item.create_time}`
    item.value = item.id
  })
  return [data?.data?.items || [], runAsync, loading] as const
}

export const useGetScenariosExecutions = () => {
  const { runAsync: run } = useRequest(() => getScenariosExecutions(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取剧本运行记录失败'))
    },
  })

  return [run] as const
}

export const useAddReport = () => {
  const { runAsync, loading } = useRequest((data: CreateReportParams) => addReport(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('报表添加失败'))
    },
  })
  return [runAsync, loading] as const
}
export const useDeleteReport = () => {
  const { runAsync, loading } = useRequest((data: DeleteReportData) => deleteReport(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('报表删除失败'))
    },
  })
  return [runAsync, loading] as const
}
export const useDownloadReport = () => {
  const { runAsync, loading } = useRequest((data: DownloadReportData) => downloadReport(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('报表下载失败'))
    },
  })
  return [runAsync, loading] as const
}

export const useViewReport = () => {
  const { runAsync, loading } = useRequest((data: ViewReportData) => viewReport(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('报表预览失败'))
    },
  })
  return [runAsync, loading] as const
}
//
export const useGetMenu = () => {
  const { runAsync, loading, data } = useRequest(() => getMenu(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取报表类型与模板类型列表失败'))
    },
  })
  return [runAsync, loading, data?.data?.items || []] as const
}
// 获取下载报表地址
export const useWsUrl = () => {
  const { runAsync: run } = useRequest(() => wsUrl(), {
    manual: true,
    onError(err: any) {
      // Message.error(err?.msg || '下载失败')
    },
  })
  return [run] as const
}

// 获取邮箱列表
export const useQueryEmailList = () => {
  const { runAsync: run, data } = useRequest(
    (params: QueryEmailListParams) => queryEmailList(params),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('获取邮箱列表失败'))
      },
    },
  )

  return [run, data?.data?.emailUsers || []] as const
}
